// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
var initialState = {};
export var auditableBallotsSlice = createSlice({
    name: "auditableBallots",
    initialState: initialState,
    reducers: {
        setAuditableBallot: function (state, action) {
            state[action.payload.electionId] = action.payload.auditableBallot;
            return state;
        },
    },
});
export var setAuditableBallot = auditableBallotsSlice.actions.setAuditableBallot;
export var selectAuditableBallot = function (electionId) { return function (state) {
    return state.auditableBallots[electionId];
}; };
export default auditableBallotsSlice.reducer;
